import PropTypes from 'prop-types';
import React from 'react';
import Avatar from 'react-avatar-edit';
import { useTranslate } from '../../../hooks/useTranslate';

const AvatarCrop = ({ onChange, onClose }) => {
  const { t } = useTranslate();
  return (
    <div className="avatar-crop">
      <Avatar width={'100%'} height={340} onCrop={onChange} label={t('profile:Click to select image')} onClose={onClose} />
    </div>
  );
};

AvatarCrop.propTypes = {
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

AvatarCrop.defaultProps = {
  onChange: () => {},
  onClose: () => {},
};

export default AvatarCrop;
